// extracted by mini-css-extract-plugin
export var backgroundDiv = "styles-module--backgroundDiv--36ef2";
export var backgroundToggle = "styles-module--backgroundToggle--59d2f";
export var buttonDiv = "styles-module--buttonDiv--b3ef2";
export var buttonPlay = "styles-module--buttonPlay--225a5";
export var iframeToggle = "styles-module--iframeToggle--3aa20";
export var number = "styles-module--number--1d148";
export var red = "styles-module--red--5b09b";
export var teal = "styles-module--teal--413a8";